function loadRecommendationsDirectly() {
    var productRecommendations = document.querySelector('.cart-drawer-related-products .related-products');
    var placeholder = document.getElementById('recommendations-placeholder');
    var template = document.getElementById('recommendations-template');
    if (!productRecommendations || !placeholder || !template) return;
    const baseProductId = productRecommendations.dataset.productId;
    const maxProducts = productRecommendations.dataset.maxProducts;
    const intent = productRecommendations.dataset.intent;
    const apiUrl = `/recommendations/products.json?product_id=${baseProductId}&limit=${maxProducts}&intent=${intent}`;

    fetch(apiUrl)
    .then(response => {
        if (!response.ok) throw new Error('API request failed');
        return response.json();
    })
    .then(data => {
        // The JSON API returns products directly
        const products = data.products || [];
        if (products.length > 0) {
            renderProducts(products);
        } else {
        // Fallback: show recent products from collections
        loadFallbackProducts();
        }
        //If we have rendered products, show the section
        var relatedProductsCard = document.querySelector('.product-card-wrapper');
        if (relatedProductsCard) {
            document.querySelector('.cart-drawer-related-products').classList.remove('hidden');
        }
    })
    .catch((error) => {
        console.log('Error fetching recommendations:', error);
        loadFallbackProducts();
    });
}

function loadFallbackProducts() {
    fetch(`/collections/all/products.json?limit=${document.querySelector('.cart-drawer-related-products .related-products').dataset.maxProducts}`)
    .then(response => response.json())
    .then(data => {
        var placeholder = document.getElementById('recommendations-placeholder');
        if (data.products && data.products.length > 0) {
        renderFallbackProducts(data.products);
        } else {
        placeholder.innerHTML = 'No products available';
        }
    })
    .catch(() => {
        placeholder.innerHTML = 'Unable to load products';
    });
}

function renderProducts(products) {
    // Clean existing modals from cart drawer
    const cartDrawer = document.querySelector('#CartDrawer');
    var placeholder = document.getElementById('recommendations-placeholder');
    var template = document.getElementById('recommendations-template');
    if (cartDrawer) {
        const existingModals = cartDrawer.querySelectorAll('.quick-add-modal');
        existingModals.forEach(modal => modal.remove());
    }

    const templateContent = template.content.cloneNode(true);
    const grid = templateContent.getElementById('recommendations-grid');
    const cartIds = JSON.parse(document.querySelector('.cart-drawer-related-products .related-products').dataset.cartContent || '[]');

    let addedCount = 0;
    const maxProducts =  document.querySelector('.cart-drawer-related-products .related-products').dataset.maxProducts;

    products.forEach(product => {
        if (addedCount >= maxProducts) return;

        const productId = parseInt(product.id);
        if (!cartIds.includes(productId)) {
            const wrapper = document.createElement('li');
            wrapper.className = '';
            if (product.element) {
                wrapper.innerHTML = product.element;
            } else {
                wrapper.innerHTML = createProductCard(product);
                // Add modal to overlay
                addModalToOverlay(product);
            }
            grid.appendChild(wrapper);
            addedCount++;
        }
    });

    if (addedCount > 0) {
        document.getElementById('recommendations-placeholder').parentNode.replaceWith(templateContent);
    } else {
        placeholder.innerHTML = 'No new products to recommend';
    }
}

function renderFallbackProducts(products) {
    // Clean existing modals from cart drawer
    var placeholder = document.getElementById('recommendations-placeholder');
    var template = document.getElementById('recommendations-template');
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
        const existingModals = cartDrawer.querySelectorAll('.quick-add-modal');
        existingModals.forEach(modal => modal.remove());
    }

    const templateContent = template.content.cloneNode(true);
    const grid = templateContent.getElementById('recommendations-grid');
    const cartIds = JSON.parse(document.querySelector('.cart-drawer-related-products .related-products').dataset.cartContent || '[]');

    let addedCount = 0;
    const maxProducts = document.querySelector('.cart-drawer-related-products .related-products').dataset.maxProducts;

    products.forEach(product => {
    if (addedCount >= maxProducts) return;

    if (!cartIds.includes(product.id)) {
        const wrapper = document.createElement('li');
        wrapper.className = '';
        wrapper.innerHTML = createProductCard(product);
        // Add modal to overlay
        addModalToOverlay(product);
        grid.appendChild(wrapper);
        addedCount++;
    }
    });

    if (addedCount > 0) {
        placeholder.parentNode.replaceChild(templateContent, placeholder);
    } else {
        placeholder.innerHTML = 'No products to show';
    }
}

function createProductCard(product) {
    // Better image handling for Shopify
    let image = '';

    // Try different image property names and formats
    if (product.featured_image) {
        image = product.featured_image;
    } else if (product.image && product.image.src) {
        image = product.image.src;
    } else if (product.image && typeof product.image === 'string') {
        image = product.image;
    } else if (product.images && product.images.length > 0) {
    if (typeof product.images[0] === 'string') {
        image = product.images[0];
    } else if (product.images[0].src) {
        image = product.images[0].src;
    }
    }

    // Add Shopify image sizing if we have an image
    if (image && !image.includes('_300x')) {
        // Add size parameter to Shopify image URLs
        if (image.includes('.jpg') || image.includes('.png') || image.includes('.webp')) {
            image = image.replace(/\.(jpg|png|webp|jpeg)/i, '_300x300.$1');
        } else {
            // If no extension, try adding size parameter
            image += '?width=300&height=300';
        }
    }

    const variant = product.variants?.[0] || {};
    const variantId = variant.id || product.id;

    return `
    <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--card card--media color-background-1 gradient" style="--ratio-percent: 125.0%;">
        <div class="card__inner ratio" style="--ratio-percent: 125.0%;">
            <div class="card__media">
            <div class="media media--transparent media--hover-effect">
                ${image ? `
                <img src="${image}" alt="${product.title}"
                    class="motion-reduce" loading="lazy"
                    style="width: 100%; height: 100%; object-fit: cover;">
                ` : `
                <div style="width: 100%; height: 200px; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999; font-size: 12px;">
                    No image
                </div>
                `}
            </div>
            </div>
        </div>
        <div class="card__content">
            <div class="card__information">
                <h3 class="card__heading h5">
                    <a href="/products/${product.handle || ''}" class="full-unstyled-link">
                    ${product.title}
                    </a>
                </h3>
            </div>
            <div class="quick-add no-js-hidden">
                <modal-opener data-modal="#QuickAdd-${product.id}">
                    <button
                    id="quick-add-${product.id}-${variantId}-submit"
                    type="submit"
                    name="add"
                    class="quick-add__submit button button--full-width button--secondary"
                    aria-haspopup="dialog"
                    aria-labelledby="quick-add-${product.id}-${variantId}-submit title-cart-drawer-${product.id}"
                    data-product-url="/products/${product.handle || ''}"
                    >
                    Choisir des options
                    <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                            <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                        </svg>
                    </div>
                    </button>
                </modal-opener>
            </div>
            </div>
            <div class="card__badge bottom left"></div>
        </div>
        </div>
    </div>
    `;
}

function addModalToOverlay(product) {
    const cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;

    const modal = document.createElement('div');
    modal.innerHTML = `
        <quick-add-modal id="QuickAdd-${product.id}" class="quick-add-modal">
            <div
            role="dialog"
            aria-label="Choose options for ${product.title}"
            aria-modal="true"
            class="quick-add-modal__content global-settings-popup"
            tabindex="-1"
            >
            <button
                id="ModalClose-${product.id}"
                type="button"
                class="quick-add-modal__toggle"
                aria-label="Close"
            >
                <svg class="icon icon-close" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/>
                </svg>
            </button>
            <div id="QuickAddInfo-${product.id}" class="quick-add-modal__content-info"></div>
            </div>
        </quick-add-modal>
    `;
    cartDrawer.appendChild(modal.firstElementChild);
}

document.addEventListener('DOMContentLoaded', function() {
    loadRecommendationsDirectly();
    initializeCartEventListeners();
});

function initializeCartEventListeners() {
    // Debounce function to prevent multiple rapid calls
    let timeout;
    const debounceRefresh = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            console.log('Refreshing cart recommendations...');
            loadRecommendationsDirectly();
        }, 300);
    };

    // Try modern Shopify pub/sub events first
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        console.log('Using Shopify pub/sub events');
        // Cart update events
        if (PUB_SUB_EVENTS.cartUpdate) {
            subscribe(PUB_SUB_EVENTS.cartUpdate, debounceRefresh);
        }
        if (PUB_SUB_EVENTS.quantityUpdate) {
            subscribe(PUB_SUB_EVENTS.quantityUpdate, debounceRefresh);
        }
        if (PUB_SUB_EVENTS.variantChange) {
            subscribe(PUB_SUB_EVENTS.variantChange, debounceRefresh);
        }
        if (PUB_SUB_EVENTS.cartError) {
            subscribe(PUB_SUB_EVENTS.cartError, debounceRefresh);
        }
    }
}
